<script>
  import { Bar, mixins  } from 'vue-chartjs'

  export default {
    extends: Bar,
    mixins: [mixins.reactiveProp],
    props:['chartData', 'color', 'titulo'],

    mounted () {
      var labels = this.chartData.labels;
      
      this.addPlugin({
         beforeUpdate(c){

           var ancho = c.chart.width;
           var l = c.chart.height;

           if(ancho<=170){
              if(c.scales["x-axis-0"].ticks===undefined){
                 c.scales["x-axis-0"].ticks = labels;
              }
                
              var largo = Math.max(...(c.scales["x-axis-0"].ticks.map(el => el.length)))
              c.scales['x-axis-0'].options.ticks.minor.fontSize = ancho / largo;
              c.scales['y-axis-0'].options.ticks.minor.fontSize = ancho / largo;
              c.options.legend.labels.fontSize = ancho / largo;

              if(c.scales['x-axis-0'].options.ticks.minor.fontSize < 7){
                c.scales['x-axis-0'].options.ticks.minor.fontSize = 7;
                c.options.legend.labels.fontSize  = c.scales['y-axis-0'].options.ticks.minor.fontSize = 7;
                c.scales["x-axis-0"].labelRotation = 90
              }
              
              if(c.scales['x-axis-0'].options.ticks.minor.fontSize > 16){
                c.scales['x-axis-0'].options.ticks.minor.fontSize = 16;
                c.options.legend.labels.fontSize  = c.scales['y-axis-0'].options.ticks.minor.fontSize = 16;
              }

           }
           //else{
            //nada por ahora
           //}
           c.options.legend.labels.boxWidth = c.options.legend.labels.fontSize;
         }
      }); 

      this.renderChart(this.chartData, {
        responsive: true, 
        maintainAspectRatio: false,
        legend:{
          labels:{
            fontColor: (this.color) ? 'white' : 'black',
            fontSize: 16,
            fontFamily:'Myriad'
          }
        }, 
        title:{
          display: true,
          text: this.titulo,
          fontColor: (this.color) ? 'white' : 'black',
          fontSize: 16,
          fontFamily:'Myriad'
        },
        animation:{
          duration: 0
        },
        tooltips:{
          enabled: false
        },
        onClick: this.enviarTabla,
        scales:{
          yAxes:[{
            ticks:{
              fontColor: (this.color) ? 'white' : 'black',
              fontSize: 14,
              fontFamily:'Myriad',
              beginAtZero: true
            }
          }],
          xAxes:[{
            ticks:{
              fontColor: (this.color) ? 'white' : 'black',
              fontSize: 14,
              fontFamily:'Myriad',
              autoSkip: false,
              maxRotation: 90
            }
          }]
        }
      });

    },
    methods:{
      enviarTabla(p, e){
        var parametros = {
          rubroId : this.chartData.datasets[0].rubroId  > 0 ? this.chartData.datasets[0].rubroId : this.chartData.datasets[0].rubros[e[0]._index],
          areaId : ((this.chartData.datasets[0].areaId > 0) || 
                    (this.chartData.datasets[0].rubroId <= 0 && this.chartData.datasets[0].areaId)) ? this.chartData.datasets[0].areaId : this.chartData.datasets[0].areas[e[0]._index]
        }
        this.$emit('crearTabla', true, parametros)
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/Graficas/Barras.vue